import type { TableDefinition, TablePart } from '../engine/tables/definition';

/**
 * Adds only the physical essentials of a conventional single-ball machine.
 * It intentionally adds no bumpers, targets, ramps, inserts or decorative art.
 * Creators who choose New Empty Table still see a completely blank playfield
 * until they explicitly request this hardware kit.
 */
export function addStandardHardware(table: TableDefinition): TableDefinition {
  if (table.parts.length > 0) return table;
  const { width, height } = table.board;
  const center = width / 2;
  const shooterX = width - 6.5;
  const flipperY = height - 9;
  const hardware: TablePart[] = [
    {
      id: 'wall-left', kind: 'wall', scoreValue: 0, thickness: 1.1,
      points: [{ x: 2, y: 2 }, { x: 2, y: height - 5 }], material: 'metal',
    },
    {
      id: 'wall-top', kind: 'wall', scoreValue: 0, thickness: 1.1,
      points: [{ x: 2, y: 2 }, { x: width - 2, y: 2 }], material: 'metal',
    },
    {
      id: 'wall-right', kind: 'wall', scoreValue: 0, thickness: 1.1,
      points: [{ x: width - 2, y: 2 }, { x: width - 2, y: height - 5 }], material: 'metal',
    },
    {
      id: 'plunger-lane',
      kind: 'plunger-lane',
      scoreValue: 0,
      bounds: { x: shooterX, y: 7, width: 4.5, height: height - 11 },
      restPosition: { x: shooterX + 2.25, y: height - 8 },
      divider: {
        points: [{ x: shooterX, y: 18 }, { x: shooterX, y: height - 7 }],
        thickness: 0.8,
      },
      stop: { center: { x: shooterX + 2.25, y: height - 4 }, width: 4, thickness: 1 },
      launchPath: [
        { x: shooterX + 2.25, y: height - 8 },
        { x: shooterX + 2.25, y: 24 },
        { x: shooterX + 2.25, y: 9 },
        { x: width - 9, y: 5 },
        { x: width - 14, y: 10 },
      ],
    },
    {
      id: 'flipper-left', kind: 'flipper-left', scoreValue: 0,
      pivot: { x: center - 9, y: flipperY }, length: 8, restAngleDeg: 30, sweepDeg: 56,
    },
    {
      id: 'flipper-right', kind: 'flipper-right', scoreValue: 0,
      pivot: { x: center + 9, y: flipperY }, length: 8, restAngleDeg: 30, sweepDeg: 56,
    },
    {
      id: 'drain', kind: 'drain', scoreValue: 0,
      center: { x: center, y: height - 1.5 }, width: 13,
    },
  ];
  return { ...table, parts: hardware };
}
